import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\app\\Common\\PageShellWithBookingClient.js");
